import React from 'react';
import { Layers } from 'lucide-react';

// A restrained, terminal-style indicator of how much of the archive is visible.
// Renders nothing once everything is unlocked (e.g. for active subscribers).
export const ArchiveDepth = ({ stats, mode = 'visibility', className = '', testid = 'archive-depth' }) => {
  if (!stats || stats.restricted <= 0) return null;
  const { total, unlocked, restricted } = stats;
  const text = mode === 'unlock'
    ? `Research Access unlocks ${restricted} additional record${restricted === 1 ? '' : 's'}`
    : `${unlocked} of ${total} archive records unlocked · ${restricted} restricted`;
  return (
    <span className={`mono-meta inline-flex items-center gap-1.5 text-[#5b6675] ${className}`} data-testid={testid}>
      <Layers className="w-3 h-3 opacity-60" /> {text}
    </span>
  );
};

// A thin visibility bar for panels — communicates a deeper layer beneath the visible one.
export const ArchiveDepthBar = ({ stats }) => {
  if (!stats || stats.restricted <= 0) return null;
  const { total, unlocked, restricted } = stats;
  const pct = total ? Math.round((unlocked / total) * 100) : 0;
  return (
    <div className="mt-7 pt-5 border-t border-[#262A36]" data-testid="archive-depth-bar">
      <div className="flex items-center justify-between mb-2">
        <span className="mono-meta text-[#6B7280] flex items-center gap-1.5"><Layers className="w-3 h-3 opacity-60" /> Archive visibility</span>
        <span className="mono-meta text-[#26B0A8]">{unlocked} / {total}</span>
      </div>
      <div className="h-1 bg-[#0c0f17] rounded-full overflow-hidden border border-[#262A36]">
        <div className="h-full bg-[#1E8F89]/70" style={{ width: `${pct}%` }} />
      </div>
      <p className="mono-meta mt-2.5 text-[#5b6675]">{restricted} record{restricted === 1 ? '' : 's'} sit beneath the visible layer.</p>
    </div>
  );
};

export default ArchiveDepth;
